<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<app-kpi-strip [kpis]="kpis" [active]="activeKpi" (activeChange)="setKpi($event)"></app-kpi-strip>

<div class="table-section">
  <div class="filter-bar filter-bar--flush">
    <div class="filter-card">
      <app-search-pill [value]="searchText" placeholder="Folio, responsable, código, etiqueta…" (valueChange)="applySearch($event)"></app-search-pill>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Periodo</mat-label>
        <mat-date-range-input [rangePicker]="periodPicker">
          <input matStartDate [(ngModel)]="periodStart" placeholder="Inicio" (dateChange)="load()">
          <input matEndDate [(ngModel)]="periodEnd" placeholder="Fin" (dateChange)="load()">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="periodPicker"></mat-datepicker-toggle>
        <mat-date-range-picker #periodPicker></mat-date-range-picker>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Tipo</mat-label>
        <mat-select [(value)]="typeFilter" (selectionChange)="load()">
          <mat-option [value]="''">Todos</mat-option>
          @for (t of types; track t.id) { <mat-option [value]="t.id">{{ t.name }}</mat-option> }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Hospital</mat-label>
        <mat-select [(value)]="placeFilter" (selectionChange)="load()">
          <mat-option [value]="''">Todos</mat-option>
          @for (p of placeOptions; track p.id) { <mat-option [value]="p.id">{{ p.alias || p.name }}</mat-option> }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Estado</mat-label>
        <mat-select [(value)]="statusFilter" (selectionChange)="load()">
          <mat-option [value]="''">Todos</mat-option>
          @for (s of statuses; track s) { <mat-option [value]="s">{{ s }}</mat-option> }
        </mat-select>
      </mat-form-field>
      <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
        <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
        <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <app-filter-chips [chips]="filterChips" [count]="dataSource.filteredData.length" [total]="dataSource.data.length" noun="registros" (remove)="removeChip($event)" (clear)="clearFilters()"></app-filter-chips>
  </div>

  <div class="list-actions">
    <button mat-stroked-button (click)="pageLoad.refresh(load())"><mat-icon>refresh</mat-icon> Actualizar</button>
    <button mat-stroked-button (click)="downloadExcel()" [disabled]="!dataSource.filteredData.length"><mat-icon>download</mat-icon> Descargar Excel</button>
    <button mat-stroked-button color="primary" (click)="openForm('DEVOLUCION')"><mat-icon>assignment_return</mat-icon> Devolución extraordinaria</button>
    <button mat-flat-button color="primary" (click)="openForm('RESGUARDO')"><mat-icon>shield</mat-icon> Nuevo resguardo</button>
  </div>

  <mat-paginator [hidden]="listView.mode !== 'table'" [pageSize]="10" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>

  <ng-template #rowMenu let-c>
    <button mat-menu-item (click)="view(c)"><mat-icon>visibility</mat-icon> Ver detalle</button>
    @if (c.type === 'RESGUARDO' && c.status === 'Abierto') {
      <button mat-menu-item (click)="giveBack(c)"><mat-icon>undo</mat-icon> Devolver resguardo</button>
    }
    @if (c.type === 'DEVOLUCION' && c.status === 'Reportado') {
      <button mat-menu-item (click)="giveBack(c)"><mat-icon>move_to_inbox</mat-icon> Reincorporar y cerrar</button>
    }
  </ng-template>

  @if (listView.mode === 'cards') {
    <div class="inv-cards cat-cards">
      @for (c of dataSource.filteredData; track c.id) {
        <div class="cat-card">
          <div class="cat-card__head">
            <span class="cat-card__title">{{ c.folio }}</span>
            <span [class]="statusChip(c.status)">{{ c.status }}</span>
          </div>
          <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__label">Tipo:</span><span class="cat-card__value">{{ typeName(c.type) }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Fecha:</span><span class="cat-card__value">{{ fmtDate(c.createdOn) }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Alias:</span><span class="cat-card__value">{{ c._place }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Locker:</span><span class="cat-card__value">{{ c._warehouse || '—' }}</span></div>
            @if (c.type === 'RESGUARDO') {
              <div class="cat-card__field"><span class="cat-card__label">Responsable:</span><span class="cat-card__value">{{ c._responsible }}</span></div>
              <div class="cat-card__field"><span class="cat-card__label">Fecha compromiso de retiro:</span><span class="cat-card__value" [class.flag]="c._overdue">{{ c._commitment || '—' }}{{ c._overdue ? ' · vencida' : '' }}</span></div>
            }
            <div class="cat-card__field"><span class="cat-card__label">Piezas:</span><span class="cat-card__value">{{ c._pieces }} ({{ c._detail }})</span></div>
            @if (c._other) {<div class="cat-card__field"><span class="cat-card__label">Alerta:</span><span class="cat-card__value flag">{{ c._other }} de otra cuenta</span></div>}
          </div>
          <div class="cat-card__actions">
            <button mat-icon-button [matMenuTriggerFor]="cm" matTooltip="Acciones"><mat-icon>more_vert</mat-icon></button>
            <mat-menu #cm="matMenu"><ng-container *ngTemplateOutlet="rowMenu; context: { $implicit: c }"></ng-container></mat-menu>
          </div>
        </div>
      }
      @if (dataSource.filteredData.length === 0) { <p class="inv-cards__empty">Sin registros con estos filtros</p> }
    </div>
  }

  <div class="table-container mat-elevation-z2" [hidden]="listView.mode !== 'table'">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="folio">
        <th mat-header-cell *matHeaderCellDef>Folio</th>
        <td mat-cell *matCellDef="let c"><code class="folio-badge">{{ c.folio }}</code></td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let c">{{ typeName(c.type) }}</td>
      </ng-container>
      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let c" class="nowrap">{{ fmtDate(c.createdOn) }}</td>
      </ng-container>
      <ng-container matColumnDef="place">
        <th mat-header-cell *matHeaderCellDef>Alias</th>
        <td mat-cell *matCellDef="let c">{{ c._place }}</td>
      </ng-container>
      <ng-container matColumnDef="warehouse">
        <th mat-header-cell *matHeaderCellDef>Locker</th>
        <td mat-cell *matCellDef="let c">{{ c._warehouse || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="responsible">
        <th mat-header-cell *matHeaderCellDef>Responsable</th>
        <td mat-cell *matCellDef="let c">{{ c._responsible || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="commitmentDate">
        <th mat-header-cell *matHeaderCellDef>Fecha compromiso de retiro</th>
        <td mat-cell *matCellDef="let c" class="nowrap">{{ c._commitment || '—' }}@if (c._overdue) {<span class="sub flag">Vencida</span>}</td>
      </ng-container>
      <ng-container matColumnDef="pieces">
        <th mat-header-cell *matHeaderCellDef>Piezas</th>
        <td mat-cell *matCellDef="let c">{{ c._pieces }}<span class="sub">{{ c._detail }}</span>@if (c._other) {<span class="sub flag">{{ c._other }} de otra cuenta</span>}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let c"><span [class]="statusChip(c.status)">{{ c.status }}</span>
          <span class="sub">{{ c.notifiedOn ? 'Aviso enviado' : 'Sin aviso' }}</span></td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let c" class="nowrap">
          <button mat-icon-button color="primary" matTooltip="Ver detalle" (click)="view(c)"><mat-icon>visibility</mat-icon></button>
          <button mat-icon-button [matMenuTriggerFor]="tm" matTooltip="Más acciones"><mat-icon>more_vert</mat-icon></button>
          <mat-menu #tm="matMenu"><ng-container *ngTemplateOutlet="rowMenu; context: { $implicit: c }"></ng-container></mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;" class="table-row"></tr>
      <tr class="no-data-row" *matNoDataRow>
        <td [attr.colspan]="columns.length"><div class="no-data"><mat-icon>inventory</mat-icon><span>Sin registros con estos filtros</span></div></td>
      </tr>
    </table>
  </div>
</div>
